import { useStyletron } from 'baseui'
import { useTranslation } from 'react-i18next'
import phoneLogo from '../../DashboardTable/phone.svg'

interface ContactCellProps {
  firstname: string
  lastname: string
  phone: string
  zohoLink: string
  email: string
}

const ContactCell = ({ firstname, lastname, phone, zohoLink, email }: ContactCellProps) => {
  const [css] = useStyletron()
  const { t } = useTranslation()
  const columnStyle = css({
    display: 'flex',
    flexDirection: 'column',
  })
  const rowStyle = css({
    display: 'flex',
    alignItems: 'center',
    marginBottom: '.25rem',
  })
  const nameStyle = css({
    textTransform: 'uppercase',
  })
  const linkStyle = css({
    display: 'flex',
    width: '100%',
    border: '2px solid limegreen',
    borderRadius: '.25rem',
    backgroundColor: 'white',
  })
  const badgeStyle = css({
    display: 'flex',
    width: '1.5rem',
    padding: '.125rem .25rem .125rem .125rem',
    backgroundColor: 'limegreen',
  })
  const imgStyle = css({
    width: '1.125rem',
    height: '1.125rem',
  })
  const contentStyle = css({
    padding: '.125rem .25rem',
    margin: '0 auto',
    textAlign: 'center' as const,
  })

  if (!phone && !firstname && !lastname) {
    return <p>{t('contractsTable:no_contact_data')}</p>
  }

  return (
    <div className={columnStyle}>
      <div className={rowStyle}>
        <span className={nameStyle}>{lastname}</span>&nbsp;<span className={nameStyle}>{firstname}</span>
      </div>
      {email && <div className={rowStyle}>{email}</div>}
      {phone && (
        <div className={rowStyle}>
          <a className={linkStyle} href={zohoLink} target='_blank' rel='noreferrer'>
            <div className={badgeStyle}>
              <img className={imgStyle} src={phoneLogo} alt='Contact' />
            </div>
            <div className={contentStyle}>
              <span>{phone}</span>
            </div>
          </a>
        </div>
      )}
    </div>
  )
}

export default ContactCell
